import React, { useState, useEffect, useCallback } from 'react';

//import { useAuth } from '../context/AuthContext'; // 가정: 인증 및 API 요청을 처리하는 AuthContext
import AdComponent from '../ads/AdComponent';
import { LeagueDetailDto } from '@playball/common/dto/League';

// --- 각 상태별로 보여줄 컴포넌트들의 예시 ---
const WaitComponent: React.FC<{ league: LeagueDetailDto }> = ({ league }) => {
    
    // 남은 시간을 계산하는 함수
    const calculateTimeLeft = useCallback(() => {
        // 백엔드에서 받은 draft_at (UTC 기준)을 Date 객체로 변환
        const draftTime = new Date(league.draft_at);
        const difference = draftTime.getTime() - Date.now();

        let timeLeft: { [key: string]: number } = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    }, [league.draft_at]);

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        // 1초마다 타이머를 실행하여 남은 시간을 업데이트
        const draftTime = new Date(league.draft_at);
        const difference = draftTime.getTime() - new Date().getTime();
        
        if (difference > 0) {
            const timer = setInterval(() => {
                const newTimeLeft = calculateTimeLeft();
                setTimeLeft(newTimeLeft);

                // 시간이 다 되면 타이머를 멈추고 부모 컴포넌트에 알림
                if (Object.keys(newTimeLeft).length === 0) {
                    clearInterval(timer);
                }
            }, 100);

            // 컴포넌트가 언마운트될 때 인터벌을 정리(cleanup)합니다.
            return () => clearInterval(timer);
        }

    }, [league.draft_at, calculateTimeLeft]);

    const timerComponents = Object.keys(timeLeft).length > 0;

    return (
        <div className="text-center league-container p-4">
            <h2>{league.name}</h2>
            <h3 className="mb-4">드래프트 시작 대기 중</h3>
            {timerComponents ? (
                <div className='mt-4'>
                    <h4>시작까지 남은 시간</h4>
                    <div className="display-4 font-weight-bold my-3" style={{ color: '#007bff' }}>
                        {timeLeft.days > 0 && `${timeLeft.days}일 `}
                        {String(timeLeft.hours || 0).padStart(2, '0')}:
                        {String(timeLeft.minutes || 0).padStart(2, '0')}:
                        {String(timeLeft.seconds || 0).padStart(2, '0')}
                    </div>
                </div>
            ) : (
                <div>
                    <h4>드래프트가 곧 시작됩니다. 잠시만 기다려주세요...</h4>
                    <div className="spinner-border mt-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            <AdComponent />
            <div className='mt-5'>
                <h3>리그코드를 사용하여 친구를 초대하세요!</h3>
                <h6>리그코드 - {league.code}</h6>
            </div>
        </div>
    );
};
export default WaitComponent;